import { Icon } from 'components/common/icons/Icon';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import { IconType } from 'types/IconType';

type PlayerTypesProps = {
    title: any;
    paragraph: any;
    playerTypes: PlayerType[];
};

export type PlayerType = {
    image: any;
    title: string;
    paragraph: string;
    keyDrivers?: { title: string; icon: IconType }[];
};

export const PlayerTypes = ({ title, paragraph, playerTypes }: PlayerTypesProps) => {
    // const getBackgroundClass = (index: number) => {
    //     switch (index) {
    //         case 0:
    //             return 'tw-bg-primary-active';
    //         case 1:
    //             return 'tw-bg-warning-accessible';
    //         case 2:
    //             return 'tw-bg-success';
    //         case 3:
    //             return 'tw-bg-primaryRed';
    //         default:
    //             return 'tw-bg-primary-active';
    //     }
    // };

    const get4BoxesElement = (playerType: PlayerType, index: number) => {
        const { title, paragraph, image, keyDrivers } = playerType;
        return (
            <div
                className="tw-shadow-xs tw-rounded tw-flex tw-flex-col tw-justify-between tw-gap-24"
                key={index}
            >
                <div>
                    <div className="tw-bg-primary tw-rounded-t tw-flex tw-justify-center">
                        <GatsbyImage
                            image={getImage(image)}
                            alt={title}
                            className={`lg:tw-w-full md:tw-w-[200px] tw-w-[150px]`}
                        />
                    </div>
                    <div className="tw-prose tw-mt-24 tw-px-24">
                        <h3 className="tw-mb-8 bold">{title}</h3>
                        <p>{paragraph}</p>
                    </div>
                </div>
                <div className="tw-p-24">
                    <h4 className="tw-text-md tw-text-neutral-subdued tw-font-semibold">
                        Key Drivers
                    </h4>
                    <ul className="tw-list-none tw-p-0 tw-mt-8">
                        {keyDrivers
                            ? keyDrivers.map((keyDriver, index) => {
                                  return (
                                      <li
                                          key={index}
                                          className={`tw-flex tw-items-center tw-gap-8 tw-py-4 tw-text-sm ${
                                              index !== keyDrivers.length ? 'tw-mt-12' : ''
                                          }`}
                                      >
                                          <Icon icon={keyDriver.icon} color="#1eafaa" />
                                          <span className="tw-m-0">{keyDriver.title}</span>
                                      </li>
                                  );
                              })
                            : null}
                    </ul>
                </div>
            </div>
        );
    };

    return (
        <div>
            <div className="tw-prose tw-mb-24 tw-mx-auto tw-text-center">
                <h2>{title}</h2>
                <p>{paragraph}</p>
            </div>
            <div className="tw-grid lg:tw-items-stretch lg:tw-grid-cols-4 md:tw-grid-cols-2 tw-grid-cols xl:tw-gap-32 tw-gap-24 tw-justify-center tw-mt-32">
                {playerTypes.map((playerType, index) => {
                    return get4BoxesElement(playerType, index);
                })}
            </div>
        </div>
    );
};
